import {

    GET_STARASSIGNMENT_LIST,
    GET_STARTYPES_LIST,
    GET_STARASSIGNMENT_TYPE_CATEGORY,
    GET_STATE_LOADING,
    GET_CARDSLIST,
    GET_LIST_HISTORICAL_TEMPLATE,
    GET_POST_TEMPLATE,
    GET_DOWNLOAD_TEMPLATE,
    GET_LIST_TYPE_STAR_LIST,
    GET_ZEN_STAR_REQUESTS,
    GET_STAR_ZEN_STATUS,
    GET_STATE_LOADING_STARASSIGNMENT,
    GET_JOB_STATUS

} from "@/views/star_assignment/store/types/types.js";

const getters = {
    [GET_STARASSIGNMENT_LIST]: state => state.typeDocumentStarassignment,
    [GET_STARTYPES_LIST]: state => state.typeStar,
    [GET_STARASSIGNMENT_TYPE_CATEGORY]: state => state.typeCategoryStarAssignment,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_CARDSLIST]: state => state.cardsList,
    [GET_LIST_HISTORICAL_TEMPLATE]:  state => state.template,
    [GET_POST_TEMPLATE]:  state => state.templateDownload,
    [GET_DOWNLOAD_TEMPLATE]:  state => state.templateDownload,
    [GET_LIST_TYPE_STAR_LIST]:  state => state.listTypeStar,
    [GET_ZEN_STAR_REQUESTS]:  state => state.listZenStarRequests,
    [GET_STAR_ZEN_STATUS]:  state => state.listStarZenStatus,
    [GET_STATE_LOADING_STARASSIGNMENT]: state => state.loadingZen,
    [GET_JOB_STATUS]: state => state.jobStatus,
};

export default getters;